var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"VodTestMain","align":"center","valign":"center"}},[_c('SysEnvTest'),_c('NetEnvTest'),_c('VodEnvTest')],1)}
var staticRenderFns = []

export { render, staticRenderFns }